import { render, staticRenderFns } from "./CampaingTrend.vue?vue&type=template&id=4d026e95&"
import script from "./CampaingTrend.vue?vue&type=script&lang=js&"
export * from "./CampaingTrend.vue?vue&type=script&lang=js&"
import style0 from "./CampaingTrend.vue?vue&type=style&index=0&id=4d026e95&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports